<template>
	<v-container fluid>
		<v-row no-gutters>
			<v-col>
				<v-text-field
					autofocus
					prepend-icon="mdi-feature-search"
					append-outer-icon="mdi-plus-circle"
					@click:append-outer="openAddItemDialog"
					label="Search Types"
					v-model="filtertext"
				></v-text-field>
			</v-col>
		</v-row>
		<v-row no-gutters>
			<v-col>
				<v-list
					class="overflow-auto"
					max-height="80vh"
				>
					<v-list-item
						v-for="asset in filteredAssets"
						:key="asset._id"
						@click="editAsset(asset)"
					>
						<v-list-item-icon>
							<v-icon v-text="asset.icon"></v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							{{asset._id}} - {{asset.name}}
						</v-list-item-content>
					</v-list-item>
				</v-list>

			</v-col>
		</v-row>
		<v-dialog
			v-model="asseteditdlg"
			fullscreen
			hide-overlay
			transition="dialog-bottom-transition"
		>
			<v-card>
				<v-toolbar
					dark
					color="primary"
				>
					<v-btn
						icon
						dark
						@click="asseteditdlg = false"
					>
						<v-icon>mdi-close</v-icon>
					</v-btn>
					<v-toolbar-title>{{editmode === "edit"?"Edit":"Add New "}} Asset Type</v-toolbar-title>
					<div class="flex-grow-1"></div>
					<v-toolbar-items>
						<v-btn
							dark
							text
							@click="saveAsset"
						>Save</v-btn>
					</v-toolbar-items>
				</v-toolbar>
				<v-card-text>
					<v-form>
						<v-text-field
							label="ID"
							v-model="activeasset._id"
							readonly
						></v-text-field>
						<v-text-field
							label="Ref"
							v-model="activeasset.ref"
							@input="refreshID"
						></v-text-field>
						<v-text-field
							label="Name"
							v-model="activeasset.name"
						></v-text-field>
						<v-select
							label="Icon"
							:append-outer-icon="activeasset.icon"
							v-model="activeasset.icon"
							:items="$store.state.iconlib"
							item-text="text"
							item-value="value"
						><template
								slot="item"
								slot-scope="data"
							>
								<v-icon>{{data.item.value}}</v-icon> {{data.item.text}}
							</template></v-select>
						<v-spacer></v-spacer>
						<b>Additional Properties</b>
						<v-divider></v-divider>
						<template v-for="prop in activeasset.props">
							<v-row>
								<v-col>
									<v-text-field label="Name"></v-text-field>
								</v-col>
							</v-row>
						</template>
					</v-form>
				</v-card-text>
			</v-card>
		</v-dialog>
	</v-container>
</template>
<script>
import moment from "moment";
import shortid from "shortid";
import "@/lib/metaphone3.js";
let test = "Duncan";
console.warn(test, test.metaphone());
const ASSETTYPE = "assettype";
const IDPREFIX = "type_";
const asset_base = {
	id: IDPREFIX,
	ref: "",
	type: ASSETTYPE,
	status: "active",
	name: "",
	description: "",
	date_created: moment().format("YYYY-MM-DD HH:mm:ss"),
	date_updated: moment().format("YYYY-MM-DD HH:mm:ss"),
	schema: {}
};
export default {
	created() {
		console.info("[INIT] Initialising...", ASSETTYPE, IDPREFIX);
	},
	data() {
		return {
			editmode: "edit",
			filtertext: "",
			asseteditdlg: false,
			activeasset: {}
		};
	},
	methods: {
		refreshID() {
			const I = this;
			let meta = I.activeasset.ref.metaphone();
			console.warn(meta);
			meta = meta.join("");
			// I.activeasset._id = IDPREFIX + I.activeasset.ref.metaphone()[0];
			I.activeasset._id = IDPREFIX + meta;
		},
		resetAsset() {
			const I = this;
			I.activeasset = JSON.parse(JSON.stringify(asset_base));
			I.activeasset.ref = shortid.generate();
			I.activeasset._id = IDPREFIX + I.activeasset.ref;
		},
		openAddItemDialog() {
			const I = this;
			I.resetAsset();
			I.asseteditdlg = true;
			I.editmode = "add";
		},
		saveAsset() {
			const I = this;
			if (I.editmode === "edit") {
				I.$store.commit("putAsset", { asset: I.activeasset });
			} else {
				I.$store.commit("addAsset", { asset: I.activeasset });
			}

			I.asseteditdlg = false;
		},
		editAsset(asset) {
			const I = this;
			I.activeasset = asset;
			I.asseteditdlg = true;
			I.editmode = "edit";
		}
	},
	computed: {
		filteredAssets() {
			let assets = [];

			let test = false;
			if (this.filtertext !== "") {
				test = new RegExp(this.filtertext, "ig");
			}

			for (let id in this.$store.getters.assettypes) {
				let asset = this.$store.getters.assettypes[id];
				let assettext = asset._id + " " + asset.name;
				if (test) {
					if (assettext.match(test)) {
						assets.push(asset);
					}
				} else {
					assets.push(asset);
				}
			}
			return assets;
		}
	}
};
</script>